export default defineNuxtRouteMiddleware(() => {
  const error = useError();
  const { clear } = useAuth();

  if (error.value) {
    const err = error.value;

    if (
      err.statusCode === 401 &&
      (err.data as { redirectTo?: string })?.redirectTo
    ) {
      if ((err.data as { clearAuth?: boolean })?.clearAuth) {
        clear();
      }

      clearError();

      if (import.meta.client) {
        window.location.href = (err.data as { redirectTo: string }).redirectTo;
        return;
      }
      return navigateTo((err.data as { redirectTo: string }).redirectTo, {
        replace: true,
      });
    }
  }
});
